<template>
  <div class="reports-wrapper">
    <div class="grid-full">
      <h3 class="bold">User Report</h3>
      <p class="mt-5 mb-20">Kindly Select the filters</p>
    </div>
    <div class="filters check">
      <el-checkbox v-model="checkAll" class="block mt-20" @change="onCheck">
        All
      </el-checkbox>
      <el-checkbox-group v-model="filters" @change="onFiltersSelect()">
        <div
          class="block mt-20"
          v-for="(aFilter, index) in reportsFilter"
          :key="aFilter + index"
        >
          <el-checkbox :label="aFilter.value" @change="onFilterChange">{{
            aFilter.label
          }}</el-checkbox>
        </div>
      </el-checkbox-group>
    </div>
    <div class="other-filters">
      <div class="other-filters-wrapper relative">
        <h3 class>Select Filter Parameters</h3>
        <div class="flex media-group mt-20">
          <el-radio-group v-model="otherFilters">
            <el-radio label="company">All Users</el-radio>
            <el-radio label="branch">By Branch</el-radio>
            <el-radio label="department">By Department</el-radio>
            <el-radio label="employee">By Individuals</el-radio>
          </el-radio-group>
        </div>
        <div
          class="mt-50 input-group"
          v-if="otherFilters === 'branch' || otherFilters === 'department'"
        >
          <label for>Select Branch</label>
          <el-select
            v-model="reports.branch_id"
            placeholder="Select a Branch"
            @change="onBranchChange"
            filterable
          >
            <el-option
              v-for="branch in branches"
              :key="branch.id"
              :label="branch.station_name"
              :value="branch.id"
            ></el-option>
          </el-select>
        </div>
        <div class="mt-20 input-group" v-if="otherFilters === 'department'">
          <label for>Select Department</label>
          <el-select
            v-model="reports.department_id"
            placeholder="All Department"
            filterable
          >
            <el-option
              v-for="dept in departments"
              :key="dept.id"
              :label="dept.department_name"
              :value="dept.id"
            ></el-option>
          </el-select>
        </div>
        <!-- </transition> -->
        <!-- <transition name="fade"> -->
        <div class="mt-50 input-group" v-show="otherFilters === 'employee'">
          <label for>Select Employees</label>
          <el-select
            v-model="reports.employee_ids"
            placeholder="Search for employees"
            filterable
            remote
            :remote-method="searchEmployees"
            multiple
          >
            <el-option
              v-for="employee in employees"
              :key="employee.id"
              :label="employee.name"
              :value="employee.id"
            ></el-option>
          </el-select>
        </div>
        <!-- </transition> -->
        <button
          class="btn btn-blue no-border btn-full-radius inline-flex flex-v-end btn-generate"
          @click.prevent="generateReport()"
        >
          <span>Generate Report</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from "lodash.debounce";
import {
  filterValueToLabelMapping,
  filterLabelToValueMapping,
} from "../helpers.js";

export default {
  data() {
    return {
      checkAll: false,
      filters: [],
      filterLabels: [],
      tableFilters: [],
      otherFilters: "company",
      showTable: false,
      selectedFormat: "",
      branches: [],
      departments: [],
      employees: [],
      reports: {
        employee_ids: [],
        branch_id: null,
        department_id: null,
      },
      reportsFilter: [
        {
          label: "Pin",
          value: "pin",
        },
        {
          label: "Name",
          value: "name",
        },
        {
          label: "Email",
          value: "email",
        },
        {
          label: "Employee Type",
          value: "employee_type",
        },
        {
          label: "Grade",
          value: "employee_grade",
        },
        {
          label: "Gender",
          value: "gender",
        },
        {
          label: "Department",
          value: "department",
        },
        {
          label: "Branch",
          value: "branch",
        },
        {
          label: "Birthday",
          value: "date_of_birth",
        },
        {
          label: "Address",
          value: "address",
        },
        {
          label: "Account Name",
          value: "account_name",
        },
        {
          label: "Genotype",
          value: "genotype",
        },
        {
          label: "Mobile Number",
          value: "mobile_number",
        },
        {
          label: "Local Government",
          value: "local_government",
        },
        {
          label: "City",
          value: "city",
        },
        {
          label: "State",
          value: "state",
        },
        {
          label: "Country",
          value: "country",
        },
        {
          label: "Employment Date",
          value: "appointment_date",
        },
        {
          label: "Blood Group",
          value: "blood_group",
        },
        {
          label: "Nationality",
          value: "nationality",
        },
        {
          label: "Religion",
          value: "religion",
        },
        {
          label: "Marital Status",
          value: "marital_status",
        },
        {
          label: "Employee Category",
          value: "employee_category",
        },
        {
          label: "Employee Designation",
          value: "employee_designation",
        },
        {
          label: "Bank Name",
          value: "bank",
        },
        {
          label: "Account Number",
          value: "account_number",
        },
        {
          label: "Bank Branch",
          value: "bank_branch",
        },
        {
          label: "Tax Id",
          value: "tax_id",
        },
        {
          label: "PFA",
          value: "pension_fund_administrator",
        },
        {
          label: "RSA Pin",
          value: "rsa_pin",
        },
      ],
    };
  },
  mounted() {
    this.getBranches();
  },
  methods: {
    onCheck(value) {
      if (value) {
        this.filters = this.reportsFilter.map(x => x.value);
        this.onFiltersSelect();
        return;
      }

      if (!value) {
        this.filters = [];
        return;
      }
    },
    onFilterChange(value) {
      if (!value && this.checkAll) {
        this.checkAll = false;
      }
    },
    generateReport() {
      const filterByIdMapping = {
        company: null,
        branch: [this.reports.branch_id],
        department: [this.reports.department_id],
        employee: this.reports.employee_ids,
      };
      let payload = {
        fetch_by: this.otherFilters,
        fetch_by_id: filterByIdMapping[this.otherFilters],
        columns: this.filters,
      };
      if (payload.fetch_by === "department") {
        payload = {
          ...payload,
          branch_id: this.reports.branch_id,
        };
      }

      this.$router.push({ name: "admim-org-view-report", params: { payload } });
    },
    onBranchChange() {
      const id = this.reports.branch_id;
      if (id) {
        this.getDepartmentsByBranch(id);
      }
    },
    onFiltersSelect() {
      this.filterLabels = this.filters.map(x => filterValueToLabelMapping[x]);
    },
    getBranches() {
      this.$store
        .dispatch("admin/organization/branch/getAllBranches")
        .then(response => {
          this.branches = response.data;
        })
        .catch(error => {
          this.$notification.error(error.message);
        });
    },
    getDepartmentsByBranch(id) {
      this.$store
        .dispatch("admin/organization/branch/getDepartmentsByBranch", id)
        .then(response => {
          this.departments = response.data;
        })
        .catch(error => {
          this.$notification.error(error.message);
        });
    },

    searchEmployees: debounce(function(searchQuery) {
      this.$store
        .dispatch("searchEmployees", searchQuery)
        .then(response => {
          this.employees = response;
        })
        .catch(() => {
          // this.$notification.error(error.message);
        });
    }, 500),
    handleSelectionChange(val) {
      this.tableFilters = val;
    },
    removeFilter(filter) {
      this.filters = this.filters.filter(
        item => item !== filterLabelToValueMapping[filter]
      );
      this.onFiltersSelect();
    },
    clear() {
      this.filters = [];
      this.toggleshowTable();
    },
    toggleshowTable() {
      this.showTable = !this.showTable;
    },
  },
};
</script>
